

import React, { useEffect, useState } from 'react'
import Footer from './Footer'
import api from '../api'
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { FaShoppingCart, FaHeart, FaRegHeart } from "react-icons/fa";
import { FaChevronUp, FaChevronDown, FaChevronRight, FaFilter, FaTimes } from "react-icons/fa";

const Newarrival = () => {
  const navigate = useNavigate();
  const [arrivalsAll, setArrivalsAll] = useState([]);
  const [filteredArrivals, setFilteredArrivals] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [mobileFilterOpen, setMobileFilterOpen] = useState(false);

  const [selectedSizes, setSelectedSizes] = useState([]);
  const [selectedColors, setSelectedColors] = useState([]);
  const [selectedSleeves, setSelectedSleeves] = useState([]);
  const [selectedNecks, setSelectedNecks] = useState([]);
  const [selectedTypes, setSelectedTypes] = useState([]);
  const [minRating, setMinRating] = useState(0);
  const [minDiscount, setMinDiscount] = useState(0);
  const [maxPrice, setMaxPrice] = useState(100000);

  const [openSize, setOpenSize] = useState(true);
  const [openColor, setOpenColor] = useState(true);
  const [openSleeve, setOpenSleeve] = useState(false);
  const [openNeck, setOpenNeck] = useState(false);
  const [openType, setOpenType] = useState(false);
  const location = useLocation();

  function handleToSingle(item) {
    navigate(`/product-details/${item._id}`, { state: { items: item } });
  }

  const queryParams = new URLSearchParams(location.search);
  const type = queryParams.get("type");

  const GetNewarrivals = async () => {
    try {
      setLoading(true);
      const res = await api.get(`/website/home_page?type=${type}`);
      setArrivalsAll(res.data.data.newArrivals);
    } catch (error) {
      console.log("error", error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { GetNewarrivals(); }, []);

  const handleCheckbox = (value, selectedArray, setSelectedArray) => {
    if (selectedArray.includes(value)) {
      setSelectedArray(selectedArray.filter(v => v !== value));
    } else {
      setSelectedArray([...selectedArray, value]);
    }
  };

  const isAnyFilterSelected = () => (
    selectedSizes.length > 0 || selectedColors.length > 0 ||
    selectedSleeves.length > 0 || selectedNecks.length > 0 ||
    selectedTypes.length > 0 || minRating > 0 ||
    minDiscount > 0 || maxPrice < 100000
  );

  const totalSelected = selectedSizes.length + selectedColors.length +
    selectedSleeves.length + selectedNecks.length + selectedTypes.length;

  const clearAllFilters = () => {
    setSelectedSizes([]); setSelectedColors([]); setSelectedSleeves([]);
    setSelectedNecks([]); setSelectedTypes([]);
    setMinRating(0); setMinDiscount(0); setMaxPrice(100000);
  };

  // ── Correct filter logic ──────────────────────────────────────────────────
  useEffect(() => {
    let filtered = arrivalsAll;

    if (selectedSizes.length > 0) {
      filtered = filtered.filter(item =>
        item.variants?.some(variant =>
          variant.sizes?.some(size =>
            selectedSizes.map(s => s.toLowerCase()).includes(size.size?.toLowerCase())
          )
        )
      );
    }

    if (selectedColors.length > 0) {
      filtered = filtered.filter(item =>
        item.variants?.some(variant =>
          selectedColors.map(c => c.toLowerCase()).includes(variant.color?.name?.toLowerCase())
        )
      );
    }

    if (selectedTypes.length > 0) {
      filtered = filtered.filter(item =>
        selectedTypes.map(t => t.toLowerCase()).includes(item.category?.name?.toLowerCase())
      );
    }

    if (minRating > 0) {
      filtered = filtered.filter(item => item.averageRating >= minRating);
    }

    if (minDiscount > 0) {
      filtered = filtered.filter(item =>
        item.variants?.some(variant =>
          variant.sizes?.some(size => (size.discount || 0) >= minDiscount)
        )
      );
    }

    filtered = filtered.filter(item => {
      const price = item.variants?.[0]?.sizes?.[0]?.discountedPrice
        || item.variants?.[0]?.sizes?.[0]?.originalPrice || 0;
      return price <= maxPrice;
    });

    setFilteredArrivals(filtered);
  }, [selectedSizes, selectedColors, selectedSleeves, selectedNecks, selectedTypes,
    minRating, minDiscount, maxPrice, arrivalsAll]);

  useEffect(() => {
    // stop browser restoring old scroll position
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    // force instant top position
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant',
    });

    const toggleVisibility = () => {
      setIsVisible(window.pageYOffset > 300);
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  // Lock body scroll when mobile drawer is open
  useEffect(() => {
    document.body.style.overflow = mobileFilterOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [mobileFilterOpen]);

  // ── Reusable filter components ────────────────────────────────────────────
  const FilterSection = ({ title, open, setOpen, children }) => (
    <div style={{ marginBottom: "12px", borderBottom: "1px solid #f0f0f0", paddingBottom: "12px" }}>
      <div
        style={{ cursor: "pointer", display: "flex", justifyContent: "space-between", alignItems: "center", padding: "4px 0" }}
        onClick={() => setOpen(!open)}
      >
        <strong style={{ fontSize: "14px" }}>{title}</strong>
        <span style={{ color: "#888", fontSize: "12px" }}>{open ? <FaChevronUp /> : <FaChevronDown />}</span>
      </div>
      {open && <div style={{ marginTop: "8px" }}>{children}</div>}
    </div>
  );

  const CheckboxList = (items, selectedArray, setSelectedArray) => (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
      {items.map(val => (
        <label
          key={val}
          style={{
            display: "flex", alignItems: "center", gap: "4px",
            padding: "4px 10px", borderRadius: "20px", cursor: "pointer", fontSize: "13px",
            border: selectedArray.includes(val) ? "1.5px solid #000" : "1px solid #ddd",
            background: selectedArray.includes(val) ? "#000" : "#fff",
            color: selectedArray.includes(val) ? "#fff" : "#333",
            transition: "all 0.15s",
          }}
        >
          <input
            type="checkbox"
            checked={selectedArray.includes(val)}
            onChange={() => handleCheckbox(val, selectedArray, setSelectedArray)}
            style={{ display: "none" }}
          />
          {val}
        </label>
      ))}
    </div>
  );

  const FilterPanel = () => (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px" }}>
        <h3 style={{ margin: 0, fontSize: "16px", fontWeight: "600" }}>
          Filters  {totalSelected > 0 && (
            <span style={{
              marginLeft: "6px", background: "#000", color: "#fff",
              borderRadius: "50%", width: "20px", height: "20px",
              display: "inline-flex", alignItems: "center", justifyContent: "center",
              fontSize: "11px"
            }}>{totalSelected}</span>
          )}
        </h3>
        {isAnyFilterSelected() && (
          <button
            onClick={clearAllFilters}
            style={{
              background: "transparent", color: "#e53935", border: "1px solid #e53935",
              borderRadius: "4px", padding: "3px 10px", cursor: "pointer", fontSize: "12px"
            }}
          >
            Clear All
          </button>
        )}
      </div>

      <FilterSection title="Size" open={openSize} setOpen={setOpenSize}>
        {CheckboxList(["S", "M", "L", "XL", "XXL"], selectedSizes, setSelectedSizes)}
      </FilterSection>

      <FilterSection title="Color" open={openColor} setOpen={setOpenColor}>
        {CheckboxList(["Red", "Blue", "Green", "Black", "White"], selectedColors, setSelectedColors)}
      </FilterSection>

      <FilterSection title="Sleeve" open={openSleeve} setOpen={setOpenSleeve}>
        {CheckboxList(["Half", "Full", "Short"], selectedSleeves, setSelectedSleeves)}
      </FilterSection>

      <FilterSection title="Neck" open={openNeck} setOpen={setOpenNeck}>
        {CheckboxList(["Round", "V-Neck", "Collar"], selectedNecks, setSelectedNecks)}
      </FilterSection>

      <FilterSection title="Type" open={openType} setOpen={setOpenType}>
        {CheckboxList(["Shirts", "jeans", "Shoes", "FULL SEELVE", "Gym Wear"], selectedTypes, setSelectedTypes)}
      </FilterSection>

      <div style={{ marginTop: "8px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", fontSize: "13px", marginBottom: "4px" }}>
          <span>Min Rating</span>
          <span style={{ fontWeight: "600" }}>⭐ {minRating}</span>
        </div>
        <input type="range" min="0" max="5" step="0.5" value={minRating}
          onChange={e => setMinRating(Number(e.target.value))} style={{ width: "100%" }} />
      </div>

      <div style={{ marginTop: "12px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", fontSize: "13px", marginBottom: "4px" }}>
          <span>Min Discount</span>
          <span style={{ fontWeight: "600" }}>{minDiscount}%</span>
        </div>
        <input type="range" min="0" max="100" step="5" value={minDiscount}
          onChange={e => setMinDiscount(Number(e.target.value))} style={{ width: "100%" }} />
      </div>

      <div style={{ marginTop: "12px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", fontSize: "13px", marginBottom: "4px" }}>
          <span>Max Price</span>
          <span style={{ fontWeight: "600" }}>₹{maxPrice === 100000 ? "Any" : maxPrice}</span>
        </div>
        <input type="range" min="0" max="100000" step="500" value={maxPrice}
          onChange={e => setMaxPrice(Number(e.target.value))} style={{ width: "100%" }} />
      </div>
    </div>
  );

  return (
    <>
      <style>{`
        .na-layout {
          display: flex;
          gap: 0;
          padding: 16px;
          min-height: 80vh;
          box-sizing: border-box;
          margin-top: 60px;
        }
        .na-sidebar {
          width: 240px;
          flex-shrink: 0;
          padding: 16px;
          border-right: 1px solid #f0f0f0;
          overflow-y: auto;
          max-height: calc(100vh - 80px);
          position: sticky;
          top: 70px;
          scrollbar-width: none;
          -ms-overflow-style: none;
          box-sizing: border-box;
        }
        .na-sidebar::-webkit-scrollbar { display: none; }
        .na-products {
          flex: 1;
          padding: 0 0 0 20px;
          box-sizing: border-box;
        }
        .na-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 16px;
        }
        .na-mobile-bar { display: none; }
        .na-drawer-overlay { display: none; }

        .na-card {
          border: 1px solid #eee;
          border-radius: 10px;
          padding: 10px;
          background: #fff;
          box-sizing: border-box;
          transition: box-shadow 0.2s;
          cursor: pointer;
        }
        .na-card:hover { box-shadow: 0 4px 16px rgba(0,0,0,0.09); }

        .na-card-img-wrap {
          perspective: 1000px;
          width: 100%;
          height: 280px;
          position: relative;
        }
        .na-card-flip {
          width: 100%; height: 100%;
          transition: transform 0.5s;
          transform-style: preserve-3d;
          position: relative;
        }
        .na-card-flip:hover { transform: rotateY(180deg); }
        .na-card-face {
          width: 100%; height: 100%;
          object-fit: cover;
          border-radius: 6px;
          backface-visibility: hidden;
          -webkit-backface-visibility: hidden;
          position: absolute; top: 0; left: 0;
        }
        .na-card-face-back { transform: rotateY(180deg); }

        .na-breadcrumb {
          padding: 12px 16px 0;
          color: #676767;
        }

        @media (max-width: 1100px) {
          .na-grid { grid-template-columns: repeat(3, 1fr); }
        }
        @media (max-width: 900px) {
          .na-grid { grid-template-columns: repeat(2, 1fr); }
          .na-card-img-wrap { height: 220px; }
        }
        @media (max-width: 768px) {
          .na-layout {
            flex-direction: column;
            padding: 8px;
            margin-top: 50px;
          }
          .na-sidebar { display: none; }
          .na-products { padding: 0; }
          .na-mobile-bar {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 8px 0 12px;
            border-bottom: 1px solid #f0f0f0;
            margin-bottom: 12px;
          }
          .na-filter-btn {
            display: flex;
            align-items: center;
            gap: 6px;
            background: #000;
            color: #fff;
            border: none;
            border-radius: 6px;
            padding: 8px 16px;
            font-size: 14px;
            cursor: pointer;
            font-weight: 500;
          }
          .na-drawer-overlay {
            display: block;
            position: fixed;
            inset: 0;
            background: rgba(0,0,0,0.45);
            z-index: 999;
          }
          .na-drawer {
            position: fixed;
            left: 0; bottom: 0;
            width: 100%;
            max-height: 85vh;
            background: #fff;
            border-radius: 20px 20px 0 0;
            z-index: 1000;
            overflow-y: auto;
            padding: 20px 16px 32px;
            box-sizing: border-box;
            animation: naSlideUp 0.25s ease;
          }
          @keyframes naSlideUp {
            from { transform: translateY(100%); }
            to { transform: translateY(0); }
          }
          .na-drawer-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 16px;
            padding-bottom: 12px;
            border-bottom: 1px solid #eee;
          }
          .na-drawer-close {
            background: #f5f5f5;
            border: none;
            border-radius: 50%;
            width: 32px; height: 32px;
            cursor: pointer;
            display: flex; align-items: center; justify-content: center;
            font-size: 14px;
          }
          .na-drawer-apply {
            width: 100%;
            margin-top: 16px;
            background: #000;
            color: #fff;
            border: none;
            border-radius: 8px;
            padding: 12px;
            font-size: 15px;
            font-weight: 600;
            cursor: pointer;
          }
        }
        @media (max-width: 480px) {
          .na-grid { grid-template-columns: repeat(2, 1fr); gap: 10px; }
          .na-card { padding: 6px; width: 170px;}
          .na-card-img-wrap { height: 180px; }
        }
        @media (max-width: 360px) {
          .na-grid { grid-template-columns: 1fr 1fr; gap: 8px; }
          .na-card-img-wrap { height: 160px; }
        }
      `}</style>

      <div className="na-layout">
        {/* Desktop Sidebar */}
        <aside className="na-sidebar">
          <FilterPanel />
        </aside>

        {/* Products Area */}
        <main className="na-products">
          {/* Mobile Top Bar */}
          <div className="na-mobile-bar">
            <span style={{ fontSize: "14px", color: "#555" }}>
              {filteredArrivals.length} products
            </span>
            <button className="na-filter-btn" onClick={() => setMobileFilterOpen(true)}>
              <FaFilter style={{ fontSize: "13px" }} />
              Filters {totalSelected > 0 && `(${totalSelected})`}
            </button>
          </div>

          {/* Product Grid */}
          <div className="na-grid">
            {loading ? (
              Array.from({ length: 8 }).map((_, i) => (
                <div key={i} className="na-card">
                  <div style={{
                    width: "100%", height: "220px", borderRadius: "6px",
                    background: "linear-gradient(90deg,#f0f0f0 25%,#e0e0e0 50%,#f0f0f0 75%)",
                    backgroundSize: "200% 100%", animation: "shimmer 1.2s infinite"
                  }} />
                  <div style={{ marginTop: "10px", height: "14px", width: "70%", background: "#f0f0f0", borderRadius: "4px" }} />
                  <div style={{ marginTop: "6px", height: "12px", width: "40%", background: "#f0f0f0", borderRadius: "4px" }} />
                  <style>{`@keyframes shimmer{0%{background-position:200% 0}100%{background-position:-200% 0}}`}</style>
                </div>
              ))
            ) : filteredArrivals.length > 0 ? (
              filteredArrivals.map(item => {
                const imageUrl = item?.image || item?.images?.[0] ||
                  item?.variants?.[0]?.images?.[0] ||
                  "https://via.placeholder.com/300x350?text=No+Image";
                const firstSize = item?.variants?.[0]?.sizes?.[0];
                const discountedPrice = firstSize?.discountedPrice;
                const originalPrice = firstSize?.originalPrice || 0;
                const discountPct = discountedPrice && originalPrice
                  ? Math.round(((originalPrice - discountedPrice) / originalPrice) * 100)
                  : 0;

                return (
                  <div key={item._id} className="na-card">
                    <div style={{ position: "relative" }}>
                      <div className="na-card-img-wrap">
                        <div className="na-card-flip">
                          <img
                            src={imageUrl}
                            alt={item?.name || "Product"}
                            className="na-card-face"
                            onClick={() => handleToSingle(item)}
                            loading="lazy"
                          />
                          <img
                            src={item?.hoverImageUrl || imageUrl}
                            alt={item?.name || "Product"}
                            className="na-card-face na-card-face-back"
                            onClick={() => handleToSingle(item)}
                            loading="lazy"
                          />
                        </div>
                      </div>

                      {/* Rating Badge */}
                      {item?.averageRating > 0 && (
                        <div style={{
                          position: "absolute", top: "6px", left: "6px",
                          backgroundColor: "rgba(0,0,0,0.65)", color: "#fff",
                          padding: "2px 7px", borderRadius: "4px",
                          fontSize: "11px", fontWeight: "bold",
                        }}>
                          ⭐ {item.averageRating.toFixed(1)}
                        </div>
                      )}

                      {/* Discount Badge */}
                      {discountPct > 0 && (
                        <div style={{
                          position: "absolute", top: "6px", right: "6px",
                          backgroundColor: "#e53935", color: "#fff",
                          padding: "2px 7px", borderRadius: "4px",
                          fontSize: "11px", fontWeight: "bold",
                        }}>
                          -{discountPct}%
                        </div>
                      )}
                    </div>

                    <div onClick={() => handleToSingle(item)}>
                      <div style={{
                        marginTop: "8px", fontWeight: "600", fontSize: "13px",
                        lineHeight: "1.3", whiteSpace: "nowrap", overflow: "hidden",
                        textOverflow: "ellipsis", color: "#111"
                      }}>
                        {item?.name || item?.title}
                      </div>

                      <div style={{ marginTop: "4px", display: "flex", alignItems: "center", gap: "6px" }}>
                        {discountedPrice ? (
                          <>
                            <span style={{ color: "#2e7d32", fontWeight: "700", fontSize: "14px" }}>
                              ₹{discountedPrice}
                            </span>
                            {(discountedPrice != originalPrice) && (
                                <span style={{ textDecoration: "line-through", color: "#aaa", fontSize: "12px" }}>
                                  ₹{originalPrice}
                                </span>
                            )}
                            
                          </>
                        ) : (
                          <span style={{ fontWeight: "700", fontSize: "14px" }}>₹{originalPrice}</span>
                        )}
                      </div>

                      <div style={{
                        marginTop: "4px", fontSize: "11px", color: "#888",
                        display: "-webkit-box", WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical", overflow: "hidden",
                      }}>
                        {item?.description || "No description"}
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <div style={{
                gridColumn: "1/-1", textAlign: "center",
                padding: "60px 20px", color: "#888"
              }}>
                <div style={{ fontSize: "40px", marginBottom: "12px" }}>🔍</div>
                <div style={{ fontSize: "16px", fontWeight: "600" }}>No products found</div>
                <div style={{ fontSize: "13px", marginTop: "6px" }}>Try adjusting your filters</div>
                {isAnyFilterSelected() && (
                  <button
                    onClick={clearAllFilters}
                    style={{
                      marginTop: "16px", background: "#000", color: "#fff",
                      border: "none", borderRadius: "6px",
                      padding: "8px 20px", cursor: "pointer", fontSize: "13px"
                    }}
                  >
                    Clear Filters
                  </button>
                )}
              </div>
            )}
          </div>
        </main>
      </div>

      {/* Mobile Filter Drawer */}
      {mobileFilterOpen && (
        <>
          <div className="na-drawer-overlay" onClick={() => setMobileFilterOpen(false)} />
          <div className="na-drawer">
            <div className="na-drawer-header">
              <span style={{ fontSize: "17px", fontWeight: "700" }}>Filters</span>
              <button className="na-drawer-close" onClick={() => setMobileFilterOpen(false)}>
                <FaTimes />
              </button>
            </div>
            <FilterPanel />
            <button
              className="na-drawer-apply"
              onClick={() => setMobileFilterOpen(false)}
            >
              Apply Filters {filteredArrivals.length > 0 && `(${filteredArrivals.length} results)`}
            </button>
          </div>
        </>
      )}

      {/* Scroll to top */}
      {isVisible && (
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          style={{
            position: "fixed", bottom: "24px", right: "24px",
            width: "44px", height: "44px", borderRadius: "50%",
            background: "#000", color: "#fff", border: "none",
            cursor: "pointer", fontSize: "18px", zIndex: 500,
            boxShadow: "0 2px 12px rgba(0,0,0,0.3)",
            display: "flex", alignItems: "center", justifyContent: "center"
          }}
        >
          ↑
        </button>
      )}

      <Footer />
    </>
  );
};

export default Newarrival;